import { render, staticRenderFns } from "./WkUser.vue?vue&type=template&id=98f275c0&scoped=true"
import script from "./WkUser.vue?vue&type=script&lang=js"
export * from "./WkUser.vue?vue&type=script&lang=js"
import style0 from "./WkUser.vue?vue&type=style&index=0&id=98f275c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f275c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98f275c0')) {
      api.createRecord('98f275c0', component.options)
    } else {
      api.reload('98f275c0', component.options)
    }
    module.hot.accept("./WkUser.vue?vue&type=template&id=98f275c0&scoped=true", function () {
      api.rerender('98f275c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NewCom/WkUserSelect/src/WkUser.vue"
export default component.exports